import { render } from "./ViewStatisticalAnalysis.vue?vue&type=template&id=67b2d3ac"
import script from "./ViewStatisticalAnalysis.vue?vue&type=script&lang=js"
export * from "./ViewStatisticalAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "E:\\IdeaProjects\\jgwgxt-qt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__